import { useState } from 'react'
import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { BorderThickness, ChevronDown2 } from 'blaze-ui/icons'
import { useUpdateStyle } from 'components/VisualStudioPlayground/VisualEditor/hooks/useUpdateStyle'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, SharedStyle, track } from '@tldraw/tldraw'
import {
  MAX_STROKE_WIDTH,
  StrokeColorStyle,
  StrokeWidthStyle,
} from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { SliderField } from 'components/Design/SliderField/SliderField'
import { SolidColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { ColorDetailRow } from './ColorDetailRow'

interface Props {
  editor: Editor
  style: SharedStyle<number>
  strokeColorStyle?: SharedStyle<string>
}

const defaultSolidColor: SolidColor = { type: 'solidColor', color: '#FFFFFF', opacity: 1 }

export const Border = track(({ editor, style, strokeColorStyle }: Props) => {
  const updateStyle = useUpdateStyle(editor)
  const [isExpanded, setIsExpanded] = useState(false)

  if (style.type === 'mixed') return null

  const isActive = style.value > 0

  const strokeValueAsColor: SolidColor | undefined =
    strokeColorStyle?.type === 'shared' ? { type: 'solidColor', color: strokeColorStyle.value, opacity: 1 } : undefined
  const formStyle = strokeValueAsColor || defaultSolidColor

  return (
    <div className={Styles.colorSection}>
      <div className={Styles.actionRow} onClick={() => setIsExpanded(!isExpanded)}>
        <BorderThickness color="var(--selected-fill)" />
        <span className={Styles.actionName}>
          <Text variant="smallList">Border</Text>
        </span>
        <ToggleButton
          name="border"
          size="sm-md"
          checked={isActive}
          handleChange={() => {
            if (isActive) {
              updateStyle(StrokeWidthStyle, 0)
              setIsExpanded(false)
            } else {
              updateStyle(StrokeWidthStyle, 1)
              setIsExpanded(true)
            }
          }}
        />
        {isExpanded ? <ChevronDown2 color="var(--dark-60)" /> : <ChevronRightSmall size={20} color="var(--dark-60)" />}
      </div>
      {isExpanded && (
        <div className={Styles.expandedSection}>
          <div className={Styles.form}>
            <div className={Styles.field}>
              <ColorDetailRow
                editor={editor}
                label="Border Color"
                color={formStyle.color}
                updateColor={(color) => updateStyle(StrokeColorStyle, color)}
              />
            </div>

            <div className={Styles.field}>
              <SliderField
                label="Border Weight"
                size="xs"
                minValue={0}
                maxValue={MAX_STROKE_WIDTH}
                value={style.value}
                onChange={(value) => updateStyle(StrokeWidthStyle, Math.round(value))}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
})
